import { Component } from '@angular/core';
import { DsButtonVariants, DsModalService, DsSearchBarModule, Icons } from '@levelaccess/design-system';

import { SecurityEntityLevel } from '@shared/constants/security-group';
import { AbstractUsersListComponent } from '../../../../components/abstract-users-list/abstract-users-list.component';
import { AsyncReportService } from '../../../../services/async-report.service';
import { LoadErrorHandler } from '../../../../services/load-error-handler';
import { NotificationService } from '../../../../services/notification.service';
import { SecurityGroupService } from '../../../../services/security-group.service';
import { SecurityUserService } from '../../../../services/security-user.service';
import { UserAclService } from '../../../../services/user-acl.service';
import { UserService } from '../../../../services/user.service';
import { SharedModule } from '../../../../shared/shared.module';
import { TranslateService } from '../../../../translate/translate.service';

@Component({
  imports: [SharedModule, DsSearchBarModule],
  selector: 'app-organization-users',
  templateUrl: './organization-users.component.html',
  providers: [AsyncReportService],
  standalone: true,
})
export class OrganizationUsersComponent extends AbstractUsersListComponent {
  protected override entityLevel: SecurityEntityLevel = SecurityEntityLevel.tenant;
  protected override errorTranslationKey: string = 'organization_details_users_loading_error';
  protected override emptyStateTranslationKey: string = 'organization_details_users_empty_state_title';
  protected override captionTranslationKey: string = 'organization_details_users_table_caption';

  protected readonly Icons: typeof Icons = Icons;
  protected readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;

  constructor(
    userService: UserService,
    securityUserService: SecurityUserService,
    loadErrorHandler: LoadErrorHandler,
    translateService: TranslateService,
    securityGroupService: SecurityGroupService,
    notificationService: NotificationService,
    dsModalService: DsModalService,
    userAclService: UserAclService,
    asyncReportService: AsyncReportService,
  ) {
    super(
      userService,
      securityUserService,
      loadErrorHandler,
      translateService,
      securityGroupService,
      notificationService,
      dsModalService,
      userAclService,
      asyncReportService,
    );
  }
}
